import clone from 'clone';

import {
    CANCEL_NOTIFICATION_START, CANCEL_NOTIFICATION_SUCCESS, CANCEL_NOTIFICATION_FAILURE,
    FETCH_NOTIFICATIONS, FETCH_NOTIFICATIONS_SUCCESS, FETCH_NOTIFICATIONS_FAILURE,
    FETCH_SCHEDULED_NOTIFICATIONS, FETCH_SCHEDULED_NOTIFICATIONS_SUCCESS, FETCH_SCHEDULED_NOTIFICATIONS_FAILURE,
    SEND_NOTIFICATION, SEND_NOTIFICATION_SUCCESS, SEND_NOTIFICATION_FAILURE,
    CLEAR_NOTIFICATION, EMPTY_NOTIFICATION, SET_NOTIFICATION
} from './constants';

const emptyNotification = {
    title: '',
    body: '',
    filter: 'global'
};

const initialState = {
    all: [],
    allMetadata: {page: 0},
    notification: {},
    scheduled: [],
    isCancelling: false,
    isFetching: false,
    isFetchingScheduled: false,
    isSending: false,
    cancelNotificationError: {},
    error: {},
    getError: {},
    getScheduledError: {}
};

function notificationsReducer(state = initialState, action) {
    switch(action.type) {
        case CLEAR_NOTIFICATION:
            return Object.assign({}, state, {
                notification: clone(emptyNotification)
            });
        case EMPTY_NOTIFICATION:
            return initialState;
        case CANCEL_NOTIFICATION_START:
            return Object.assign({}, state, {
                isCancelling: true,
                cancelNotificationError: {}
            });
        case CANCEL_NOTIFICATION_SUCCESS:
            return Object.assign({}, state, {
                isCancelling: false
            });
        case CANCEL_NOTIFICATION_FAILURE:
            return Object.assign({}, state, {
                isCancelling: false,
                cancelNotificationError: action.error
            });
        case FETCH_NOTIFICATIONS:
            return Object.assign({}, state, {
                isFetching: action.hideSpinner !== true,
                getError: {}
            });
        case FETCH_NOTIFICATIONS_SUCCESS:
            return Object.assign({}, state, {
                isFetchingScheduled: false,
                all: action.data,
                allMetadata: action.meta
            });
        case FETCH_NOTIFICATIONS_FAILURE:
            return Object.assign({}, state, {
                isFetching: false,
                getError: action.error
            });
        case FETCH_SCHEDULED_NOTIFICATIONS:
            return Object.assign({}, state, {
                isFetchingScheduled: true,
                getScheduledError: {}
            });
        case FETCH_SCHEDULED_NOTIFICATIONS_SUCCESS:
            return Object.assign({}, state, {
                isFetchingScheduled: false,
                scheduled: action.data
            });
        case FETCH_SCHEDULED_NOTIFICATIONS_FAILURE:
            return Object.assign({}, state, {
                isFetchingScheduled: false,
                getScheduledError: action.error
            });
        case SEND_NOTIFICATION:
            return Object.assign({}, state, {
                isSending: true,
                error: {}
            });
        case SEND_NOTIFICATION_SUCCESS:
            return Object.assign({}, state, {
                isSending: false,
                notification: {}
            });
        case SEND_NOTIFICATION_FAILURE:
            return Object.assign({}, state, {
                isSending: false,
                error: action.error
            });
        case SET_NOTIFICATION:
            return Object.assign({}, state, {
                notification: action.data
            });
        default:
            return state;
    }
}

export default notificationsReducer;



// WEBPACK FOOTER //
// ./src/containers/NotificationsPage/store/reducers.js